import { writable } from 'svelte/store';
function createMobileNavStateStore() {
    const { subscribe, update } = writable({
        isOpen: false,
        activeContentStack: [],
        showHeightTransition: true,
    });
    function push(content) {
        update((state) => {
            state.activeContentStack.push(content);
            return state;
        });
    }
    function pop() {
        update((state) => {
            state.activeContentStack.pop();
            return state;
        });
    }
    function toggle(options) {
        const openFromSubnav = options?.openFromSubnav ?? false;
        update((state) => {
            state.showHeightTransition = !openFromSubnav;
            state.activeContentStack = [];
            state.isOpen = !state.isOpen;
            return state;
        });
    }
    return {
        push,
        pop,
        subscribe,
        toggle,
    };
}
export const mobileNavStateStore = createMobileNavStateStore();
